<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useSessionStore } from '../../../stores/session'

const sessionStore = useSessionStore()
const { isLoggedIn } = storeToRefs(sessionStore)
const { logout } = sessionStore

const doLogout = () => {
  logout()
  window.location.href = '/?notify=logout-success'
}
</script>

<template>
  <ul v-if="!isLoggedIn"
      class="bx-header__user-navi">
    <li>
      <a href="/registrieren"
         class="bx-typo--link">
        Konto erstellen
      </a>
    </li>
    <li>
      <a href="/anmelden"
         class="bx-typo--link">
        Anmelden
      </a>
    </li>
  </ul>
  <ul v-else
      class="bx-header__user-navi">
    <li>
      <a href="/meine-kochbuecher"
         class="bx-typo--link">
        Meine Kochbücher
      </a>
    </li>
    <li>
      <a href="/mein-profil"
         class="bx-typo--link">
        Mein Profil
      </a>
    </li>
    <li>
      <a class="bx-typo--link"
         href="#"
         @click="doLogout">
        Abmelden
      </a>
    </li>
  </ul>
</template>
